import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Controller } from "react-hook-form"
import { withTranslation } from 'react-i18next'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import Input from 'react-phone-number-input/input'
import ReactCountryFlag from "react-country-flag"


export default withTranslation()(function PhoneNumberInput(props) {
  const { t, name, label, className: { inputClass, bodyClass }, singleInputClassName, passedValue = 0, country = false, errorState = (data) => data, disabled = false, labelWithin = false, code } = props
  // const Flag = Flags['us'];
  const { control, watch, trigger } = useFormContext()
  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
        const invalid = Boolean(error) || (watch(name) ? !isValidPhoneNumber(watch(name)) : false)
        const borderClass = invalid ? 'border-red-500' : 'border-gray-300'
        const errorMessage = error?.type ? t(`misc.validations.${error.type}`) : (error?.message ?? `Invalid phone number for selected country (${country})`)

        return (
          <div className="text-left">
            {!labelWithin ? <label htmlFor={name} className="text-secondary text-sm inline-block mb-2">{label}</label> : null}
            {country ?
              <div className={`flex items-center gap-2 w-full border p-3 bg-input rounded-md ${borderClass}`}>
                <div className='flex gap-2 items-center shrink-0'>
                  <ReactCountryFlag countryCode={country} svg style={{
                    width: '28px',
                    height: '20px',
                  }} />
                  <div style={{ fontSize: '14px' }}>+{code}</div>
                </div>

                <Input
                  defaultCountry='NG'
                  country={country}
                  className={singleInputClassName || 'w-full bg-transparent outline-none'}
                  onChange={
                    (val) => { onChange(val); errorState(watch(name) ? isValidPhoneNumber(watch(name)) : false) }
                  }
                  onBlur={
                    onBlur
                  }
                  value={value ? value?.countryCallingCode : passedValue}
                  error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}

                />
              </div>
              :
              <PhoneInput
                defaultCountry="NG"
                numberInputProps={{
                  className: `${inputClass || 'py-3 rounded-r-md !bg-input'}`
                }}
                className={bodyClass || `border p-3 bg-input w-full rounded-md pl-2 ${borderClass}`}
                onChange={
                  (val) => { onChange(val); errorState(watch(name) ? isValidPhoneNumber(watch(name)) : false) }
                }
                onBlur={
                  onBlur
                }
                value={value ? value : passedValue}
                disabled={disabled}
              />
            }
            {
              watch(name) && invalid && (
                <p className="text-xs text-red-500 mt-1">{errorMessage}</p>
              )
            }
          </div>
        )
      }}
    />
  )
})